export const GENERATE_TEXT_CONTENT_TYPES = [
  'Attention Grabbing',
  'Branding',
  'Call to Action',
  'Community Minded',
  'Cross Channel',
  'Time Sensitive',
];
